import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallCampaignInfoBackgroundImage } from '../../../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallImage from '../../common/PrizeWallImage/PrizeWallImage';

function PrizeWallInfoBackground() {
  const backgroundImage = useSelector(
    selectPrizeWallCampaignInfoBackgroundImage,
  );

  return (
    <PrizeWallImage
      {...backgroundImage}
      contentFit="fill"
      position="absolute"
      inset={0}
    />
  );
}

export default memo(PrizeWallInfoBackground);
